import produce from 'immer';
import { StatusListaRPAEnum } from '../../enums';
import { setTabContentPorStatus } from '../../utils/setTabContentPorStatus';

export const Types = {
  GET_LISTAS_RPA_REQUEST: '@lista/GET_LISTAS_RPA_REQUEST',
  GET_LISTAS_RPA_SUCCESS: '@lista/GET_LISTAS_RPA_SUCCESS',
  GET_LISTAS_RPA_ERROR: '@lista/GET_LISTAS_ERROR',
};

const INITIAL_STATE = {
  getListasRPA: {
    loading: false,
    success: false,
    response: {
      Todas: { data: [], size: 0 },
      Processar: { data: [], size: 0 },
      Reprocessar: { data: [], size: 0 },
      Liberar: { data: [], size: 0 },
      Alteracao: { data: [], size: 0 },
      PreVenda: { data: [], size: 0 },
      Importacao: { data: [], size: 0 },
      ComErros: { data: [], size: 0 },
    },
    unsuccessResponse: [],
    error: null,
  },
};

export default function listasRPA(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_LISTAS_RPA_REQUEST: {
        draft.getListasRPA.loading = true;
        break;
      }
      case Types.GET_LISTAS_RPA_SUCCESS: {
        draft.getListasRPA.loading = false;
        setTabContentPorStatus(
          action.payload.response,
          StatusListaRPAEnum.returnTabForName,
          draft.getListasRPA.response
        );

        draft.getListasRPA.success = action.payload.success;
        break;
      }
      case Types.GET_LISTAS_RPA_ERROR: {
        draft.getListasRPA.loading = false;
        draft.getListasRPA.error = action.payload.error;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  getListasRPARequest: (params, tipoStatus) => ({
    type: Types.GET_LISTAS_RPA_REQUEST,
    payload: { params, tipoStatus },
  }),
  getListasRPASuccess: (response, success) => ({
    type: Types.GET_LISTAS_RPA_SUCCESS,
    payload: { response, success },
  }),
  getListasRPAError: (error) => ({
    type: Types.GET_LISTAS_RPA_ERROR,
    payload: { error },
  }),
};
